module.exports = __webpack_public_path__ + "img/chat-loading@2x.47c57066.png";